
export interface RetweetResponse {
  retweetCount?: number;
  success?: boolean;
}
